import { ReactNode } from "react";

import ThemePageLayout from "#/components/shared/theme/ThemePageLayout";

export interface ThemePageProps {
  themeExample?: ReactNode;
}

export const ThemePage = () => {
  return <ThemePageLayout />;
};

export default ThemePage;
